import { HttpClient } from "../common/http-client";
import { Environment } from "../environment/app-settings";
import { IGetPredefinedOfferDTO, IPredefinedSingleOfferResponse, IRecalculateOffert, ISubmitChooseOfferData } from '../store/types'


let instance: OfferService


export interface RecalculateOfferProps { 
   offerId: string | undefined,
   instalments: number,
   requestedAmount: number,
}

export enum PREDEFINED_OFFERS_CUSTOM_ERROR_CODES { //!!! IMPORTANT - Taki sam enum występuje w backendzie - otp-backend\src\OTP.Application\DTOS\Api\PredefinedOffersResponse.cs
    DEFAULT = 0,
    APPLICATION_NOT_FOUND = 10,
    OUT_OF_LIMITS_ERROR = 20,
    LONG_PERIOD_OFFER_CALCULATION_FAILED = 30,
    SHORT_PERIOD_OFFER_CALCULATION_FAILED = 35,
}

export interface GetPredefinedOfferCustomErrorFromBackend { 
  status: number;
  data : {
    errorCode: PREDEFINED_OFFERS_CUSTOM_ERROR_CODES;
    message: string;
    minInstallmentNumber?: number;
    maxInstallmentNumber?: number;
  }
}

export interface ChoseOfferResponseDTO {
  code?: string;
  message?: string | null 
}
export class OfferService {
  private readonly _client: HttpClient;
  private readonly _url = "offert";
  private readonly _recalculateOfferUrlPath = '/recalculateOffer';
  private readonly _recalculatePredefinedOfferUrlPath = '/recalculatePredefinedOffer';
  private readonly _chooseOfferUrlPath = '/chooseOffer'
  private readonly _getPredefinedOfferUrlPath = '/getPredefinedOffers'


  constructor() {
    if (instance) { //SINGLETON DESIGN PATTERN
       throw new Error("New instance cannot be created!!");
    }
 
    instance = this;
    this._client = new HttpClient(Environment.apiUrl + this._url);
  }


  public async recalculateOffer(recalculateOfferParams: RecalculateOfferProps, signal?: AbortSignal): Promise<IRecalculateOffert> {
   return (await this._client.post<IRecalculateOffert, RecalculateOfferProps>(
      this._recalculateOfferUrlPath,
      recalculateOfferParams,
      true,
       signal
    )).data;
  }

  public async recalculatePredefinedOffer(recalculateOfferParams: RecalculateOfferProps, signal?: AbortSignal): Promise<IRecalculateOffert> {
   return (await this._client.post<IRecalculateOffert, RecalculateOfferProps>(
      this._recalculatePredefinedOfferUrlPath,
      recalculateOfferParams,
      true,
       signal
    )).data;
  }

  public async chooseOffer(chooseOfferParams: ISubmitChooseOfferData): Promise<ChoseOfferResponseDTO> {
     return (await this._client.post<ChoseOfferResponseDTO, ISubmitChooseOfferData>(
       this._chooseOfferUrlPath, 
       chooseOfferParams,
       true
     )).data;
  }

  public async getPredefinedOffer(getPredefinedOfferParams?: IGetPredefinedOfferDTO): Promise<IPredefinedSingleOfferResponse[]> {
     return (await this._client.post<IPredefinedSingleOfferResponse[], IGetPredefinedOfferDTO>(
       this._getPredefinedOfferUrlPath, 
       getPredefinedOfferParams ?? {},
       true
     )).data;
  }
}


let offerService = Object.freeze(new OfferService())//SINGLETON DESIGN PATTERN
export default offerService;